import React from 'react';
import { Link } from 'react-router';
import AppRoutes from '../../routes/routes';
import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';
import AxonIcon from '../icons/axon-icon';

export default class MarketingFooter extends React.Component {
    render() {
        return (
            <footer>
                <div className="footer-inner">
                    <div className="footer-brand">
                        <img className="footer-brand-logo" src={require('../../../images/logo-white.svg')} width="200" alt="Neurochecklists" />
                        <div className="footer-brand-axon">
                            <span className="footer-brand-name">Axon</span>
                            <span className="footer-brand-divider" aria-hidden="true">|</span>
                            <AxonIcon size={32} color="rgba(255,255,255,0.8)" />
                        </div>
                        <p className="footer-tagline">The clinical neurology AI assistant grounded in evidence. Built for researchers, fellows, and clinicians who demand accuracy.</p>
                    </div>

                    <div>
                        <div className="footer-col-title">Product</div>
                        <ul className="footer-links">
                            <li><Link to={AppRoutes.explore}>Explore</Link></li>
                            <li><Link to={AppRoutes.axon}>Axon</Link></li>
                            <li><Link to={AppRoutes.pricing}>Pricing</Link></li>
                        </ul>
                    </div>

                    <div>
                        <div className="footer-col-title">Connect</div>
                        <ul className="footer-links">
                            <li><a target="blank" href={AppRoutes.substack} title="Substack" rel="noopener noreferrer">Substack</a></li>
                            <li><a href={AppRoutes.news} target="_blank" title="The Neurology Lounge Podcast" rel="noopener noreferrer">Podcast</a></li>
                            <li><a href={AppRoutes.substackSubscribe} target="_blank" title="Newsletter" rel="noopener noreferrer" onClick={() => PostHogService.capture(PostHogEvents.SUBSTACK_SUBSCRIBE_CLICKED, { source: 'footer' })}>Newsletter</a></li>
                            <li><a href={AppRoutes.facebook} target="_blank" rel="noopener noreferrer">Facebook</a></li>
                            <li><a href={AppRoutes.twitter} target="_blank" rel="noopener noreferrer">Twitter</a></li>
                            <li><a href={AppRoutes.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                        </ul>
                    </div>

                    <div>
                        <div className="footer-col-title">Company</div>
                        <ul className="footer-links">
                            <li><Link to={AppRoutes.about}>About</Link></li>
                            <li><Link to={AppRoutes.faqs}>FAQ</Link></li>
                            <li><Link to={AppRoutes.contact}>Contact</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <span className="footer-copy">© {new Date().getFullYear()} Neurochecklists Ltd. All rights reserved.</span>
                    <div className="footer-legal">
                        <Link to={AppRoutes.privacy} onClick={() => PostHogService.capture(PostHogEvents.FOOTER_LINK_CLICKED, { label: 'Privacy Policy' })}>Privacy Policy</Link>
                        <Link to={AppRoutes.data} onClick={() => PostHogService.capture(PostHogEvents.FOOTER_LINK_CLICKED, { label: 'Data Policy' })}>Data Policy</Link>
                        <Link to={AppRoutes.tcs} onClick={() => PostHogService.capture(PostHogEvents.FOOTER_LINK_CLICKED, { label: 'Terms and Conditions' })}>Terms and Conditions</Link>
                        <Link to={AppRoutes.credits} onClick={() => PostHogService.capture(PostHogEvents.FOOTER_LINK_CLICKED, { label: 'Site Credits' })}>Site Credits</Link>
                    </div>
                </div>
            </footer>
        );
    }
}
